<template>
  <div class="wrapper">
    <span class="w-title">企业信息</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="form-panel">
        <div class="form-panel-head">基本信息</div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label v-if="currentUser.role==='super'" :class="editing||adding?'required':''">事务所:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-autocomplete
                  v-if="currentUser.role==='super'"
                  ref="form.firmId"
                  v-model="item.firmId"
                  no-data-text="无可用数据"
                  :items="firms"
                  :label="detailing?'':'请选择事务所'"
                  outline
                  solo
                  :rules="[rules.required]"
                  :disabled="detailing"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <!--不需要客户状态-->
              </v-flex>
              <v-flex xs9 md4>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">公司名称:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.name"
                  v-model="item.name"
                  :label="detailing?'':'请输入公司名称'"
                  outline
                  solo
                  :rules="[rules.required]"
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>行业类型:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-autocomplete
                  ref="form.industry"
                  v-model="item.industry"
                  no-data-text="无可用数据"
                  :items="industries"
                  :label="detailing?'':'请选择行业类型'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>所在区域:</label>
              </v-flex>
              <v-flex xs9 md10>
                <v-layout v-if="detailing" wrap>
                  <v-flex xs4>
                    <v-text-field
                      outline
                      solo
                      :disabled="detailing"
                      :value="''+(item.province?item.province:'')+(item.city?item.city:'')+(item.area?item.area:'')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="!detailing" wrap>
                  <v-flex xs12 md4>
                    <v-select
                      ref="form.province"
                      v-model="item.province"
                      no-data-text="无可用数据"
                      :label="detailing?'':'省份'"
                      :items="provinces"
                      outline
                      solo
                      @change="onProvinceChange"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-select
                      ref="form.city"
                      v-model="item.city"
                      no-data-text="无可用数据"
                      :items="cities"
                      :label="detailing?'':'城市'"
                      outline
                      solo
                      @change="onCityChange"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-select
                      ref="form.area"
                      v-model="item.area"
                      no-data-text="无可用数据"
                      :items="areas"
                      :label="detailing?'':'区县'"
                      outline
                      solo
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>邮编:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.postalCode"
                  v-model="item.postalCode"
                  :label="detailing?'':'请输入邮编'"
                  :rules="[rules.postalCode]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="(editing||adding)&&isOpenStatus?'required':''">联系人:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.contactName"
                  v-model="item.contactName"
                  :label="detailing?'':'请输入联系人姓名'"
                  :rules="isOpenStatus?[rules.required]:[]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>职位:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.contactTitle"
                  v-model="item.contactTitle"
                  :label="detailing?'':'请输入职位'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">手机号码:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.contactPhoneNumber"
                  v-model="item.contactPhoneNumber"
                  :label="detailing?'':'请输入联系人手机号码'"
                  :rules="[rules.required, rules.phoneNumber]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>QQ:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.contactQQ"
                  v-model="item.contactQQ"
                  :label="detailing?'':'请输入联系人QQ'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>邮箱:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.contactEmail"
                  v-model="item.contactEmail"
                  :label="detailing?'':'请输入联系人邮箱'"
                  :rules="[rules.email]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="(editing||adding)&&isOpenStatus?'required':''">法人:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.legalRepresentative"
                  v-model="item.legalRepresentative"
                  :label="detailing?'':'请输入法人'"
                  :rules="isOpenStatus?[rules.required]:[]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="(editing||adding)&&isOpenStatus?'required':''">电话:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.phoneNumber"
                  v-model="item.phoneNumber"
                  :label="detailing?'':'请输入电话'"
                  :rules="isOpenStatus?[rules.required,rules.isTel]:[]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="(editing||adding)&&isOpenStatus?'required':''">注册地址:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.registeredAddress"
                  v-model="item.registeredAddress"
                  :label="detailing?'':'请输入详细注册地址'"
                  :rules="isOpenStatus?[rules.required]:[]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>网址:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.website"
                  v-model="item.website"
                  :label="detailing?'':'请输入公司网址'"
                  :rules="[rules.website]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>注册资本:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.registeredCapital"
                  v-model="registeredCapitalTenK"
                  :label="detailing?'':'请输入注册资本'"
                  :rules="isOpenStatus?[rules.isNumber]:[]"
                  :suffix="detailing?'':'万元'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <!--不需要客户等级-->
              </v-flex>
              <v-flex xs9 md4>
              </v-flex>

              <v-flex xs3 md2 class="d-flex mt-2">
                <label>公司介绍:</label>
              </v-flex>
              <v-flex xs9 md10>
                <v-textarea
                  v-if="!detailing"
                  ref="form.description"
                  v-model="item.description"
                  :label="detailing?'':'请输入公司详细介绍'"
                  outline
                  solo
                ></v-textarea>
                <p v-if="detailing" class="detail-area">{{ item.description }}</p>
              </v-flex>
            </v-layout>
          </v-container>
        </div>

        <!--财务信息-->
        <div class="form-panel-head">财务信息</div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="(editing||adding)&&isOpenStatus?'required':''">税务性质:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-select
                  ref="form.taxType"
                  v-model="item.taxType"
                  :label="detailing?'':'请选择税务性质'"
                  :items="taxTypes"
                  :rules="isOpenStatus?[rules.required]:[]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-select>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="(editing||adding)&&isOpenStatus?'required':''">税号:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.taxId"
                  v-model="item.taxId"
                  :label="detailing?'':'请输入税号'"
                  :rules="isOpenStatus?[rules.required]:[]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="(editing||adding)&&isOpenStatus?'required':''">发票抬头:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.receiptTitle"
                  v-model="item.receiptTitle"
                  :label="detailing?'':'请输入发票抬头'"
                  :rules="isOpenStatus?[rules.required]:[]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>开户行:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.bankBranch"
                  v-model="item.bankBranch"
                  :label="detailing?'':'请输入开户行'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>开票地址:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.receiptAddress"
                  v-model="item.receiptAddress"
                  :label="detailing?'':'请输入开票地址'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>开票电话:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.receiptPhoneNumber"
                  v-model="item.receiptPhoneNumber"
                  :label="detailing?'':'开票电话'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>银行账号:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.bankAccountNumber"
                  v-model="item.bankAccountNumber"
                  :label="detailing?'':'请输入银行账号'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </div>
    </v-container>


    <v-container fluid grid-list-md class="pa-0 my-5">
      <v-layout>
        <v-flex xs3 md4></v-flex>
        <v-flex xs6 md4 style="display:flex;justify-content: space-around">
          <v-btn outline @click="cancel">返回</v-btn>
          <v-btn v-if="!detailing" color="info" @click="save">保存</v-btn>
        </v-flex>
        <v-flex xs3 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import axios from "../axios";
  import {mapState} from "vuex";
  import {mapActions} from "vuex";

  export default {
    name: "CompanyForm",
    components: {},
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
        provinces: state => state.provinces,
        taxTypes: state => state.taxTypes,
        firms: state => state.firms,
      }),
      id() {
        console.log(this.currentUser.companyId);
        return this.currentUser.companyId;
      },
      adding() {
        //return !this.$route.params.companyId;
        return false;
      },
      editing() {
        //return (!!this.id) && this.$route.name === "company-reviews-form-edit"
        return true;
      },
      detailing() {
        //return (!!this.id) && this.$route.name === "company-reviews-form-detail"
        return false;
      },
      isOpenStatus() {
        //如果是已开通用户，应该一些项是必填
        //return this.item.status === '已开通';
        return true;
      },
      registeredCapitalTenK: {
        get: function () {
          if (this.item.registeredCapital == null) {
            return null;
          } else {
            return this.item.registeredCapital / 10000;
          }
        },
        set: function (newValue) {
          if (newValue == null || newValue.length === 0) {
            this.item.registeredCapital = null;
          } else {
            this.item.registeredCapital = newValue * 10000;
          }
        }
      }
    },
    data: () => {
      return {
        rules: {
          required: value => !!value || "必填",
          length5: value => (!!value && value.length >= 5) || "长度至少为5",
          length8: value => (!!value && value.length >= 8) || "长度至少为8",
          phoneNumber: value => {
            const pattern = /^1\d{10}$/;
            return pattern.test(value) || "请输入正确的手机号";
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            // eslint-disable-next-line
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的邮箱";
          },
          website: value => {
            const pattern = /^(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
            // eslint-disable-next-line
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的网址";
          },
          postalCode: value => {
            const pattern = /^\d{6}$/;
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的邮编";
          },
          isNumber: value => {
            const pattern = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;  ///^\d+$/
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的金额";
          },
          isTel: value => {//固定电话
            const pattern = /^\d+(-\d+)*$/;
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的电话";
          }
        },
        hasErrors: false,
        item: {},
        industries: [],
        cities: [],
        areas: [],
      };
    },
    methods: {
      ...mapActions(["fetchCities", "fetchAreas", "setLoading"]),
      resetForm() {
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          )
            this.$refs["form." + f].resetValidation();
        });
      },

      save() {
        this.validate();

        if (!this.hasErrors) {
          //去掉录入后，又不想录入 输入的空项
          for (let i in this.item) {
            if (this.item[i] === "") {
              delete this.item[i];
            }
          }

          this.setLoading(true);
          axios
            .put("/company-reviews/" + this.item.companyId, this.item)
            .then((res) => {
              this.$store.dispatch("fetchMiniCompanies", {role: this.currentUser.role});
              this.setLoading(false);

              this.$confirm("修改成功", {buttonFalseText: null}).then(() => {
                this.cancel();
              });
            })
            .catch(reason => {
              if (reason.response.data.message === '找不到') {
                axios
                  .post("/company-reviews", this.item)
                  .then((res) => {
                    this.$store.dispatch("fetchMiniCompanies", {role: this.currentUser.role});
                    this.$confirm("提交成功", {buttonFalseText: null}).then(() => {
                      this.cancel();
                    });
                    this.setLoading(false);
                  })
                  .catch(reason => {
                    this.$confirm(reason.response.data.message, {
                      buttonFalseText: null
                    });
                    this.setLoading(false);
                  });
              } else {
                this.$confirm(reason.response.data.message, {
                  buttonFalseText: null
                });
                this.setLoading(false);
              }

            });

        }
      },
      updateCities() {
        if (this.item.province) {
          this.fetchCities({
            province: this.item.province,
            callback: results => {
              this.cities = results;
            }
          });
        }
      },
      updateAreas() {
        if (this.item.province && this.item.city) {
          this.fetchAreas({
            province: this.item.province,
            city: this.item.city,
            callback: results => {
              this.areas = results;
            }
          });
        }
      },
      onProvinceChange() {
        this.item.city = null;
        this.item.area = null;
        this.cities = [];
        this.areas = [];
        this.updateCities();
      },
      onCityChange() {
        this.item.area = null;
        this.areas = [];
        this.updateAreas();
      },
      validate() {
        this.hasErrors = false;

        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      },


    },
    created() {
      axios
        .get("/lookups/company/industries")
        .then(response => {
          this.industries = response.data;
        })
        .catch(() => {
        });

      if (this.currentUser.role === 'super') {
        this.$store.dispatch("fetchFirms");
      }

      if (this.editing || this.detailing) {
        this.setLoading(true);

        axios.get("/company-reviews/me").then(res => {
          this.item = res.data;
          this.updateCities();
          this.updateAreas();
          this.setLoading(false);
          // console.log(this.item);
        })
          .catch(reason => {
            if (reason.response.data.message === '找不到') {
              axios.get("/companies/me").then(res => {
                this.item = res.data;
                this.updateCities();
                this.updateAreas();
                this.setLoading(false);
              }).catch(reason => {
                this.$confirm(reason.response.data.message, {
                  buttonFalseText: null
                });
                this.setLoading(false);
              });
            } else {
              this.$confirm(reason.response.data.message, {
                buttonFalseText: null
              });
              this.setLoading(false);
            }
          });

      } else {
        this.item = {
          name: null,
          industry: null,
          postalCode: null,
          contactName: null,
          contactPhoneNumber: null,
          contactQQ: null,
          contactTitle: null,
          legalRepresentative: null,
          contactEmail: null,
          registeredAddress: null,
          registeredCapital: null,
          phoneNumber: null,
          website: null,
          description: null,
          taxType: null,
          taxId: null,
          receiptTitle: null,
          bankBranch: null,
          bankAccountNumber: null,
          province: null,
          city: null,
          area: null,


          //contactPhoneCountryCode:null,

          receiptAddress: null,//开票地址
          receiptPhoneNumber: null,//开票电话
          firmId: this.currentUser.firmId,
          companyId: this.currentUser.companyId//只有user时才可以添加
        };
      }
    }
  };
</script>

<style scoped></style>
